import React from 'react';

import Paper from '@material-ui/core/Paper';

import { compose } from 'recompose';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { ThemeContext } from '../../components/Session';
import { darken, lighten } from '@material-ui/core/styles/colorManipulator';
import Utilities from '../../utils/utilities';
import { ReactComponent as Vectors } from '../../images/Vectors.svg';
import { withFirebase } from '../../components/Firebase';

const styles = (theme) => ({
  paper: {
    padding: theme.spacing(5),
    borderRadius: theme.spacing(1),
    marginTop: theme.spacing(5),
    marginLeft: theme.spacing(5),
    marginRight: theme.spacing(5),
    maxWidth: '1000px',
  },
  linkRow: {
    margin: theme.spacing(5),
  },
  backgroundDivStyle: {
    backgroundColor: theme.palette.primary.main,
    height: '350px',
    right: '0px',
    left: '0px',
    position: 'absolute',
    zIndex: '-1',
  },
  vectors: {
    position: 'absolute',
    left: '0px',
    right: '0px',
    bottom: '0px',
  },
  preLine: {
    whiteSpace: 'pre-line',
  },
});

class CustomerViewQuoteConditionsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    this.setState({ loading: true });
    this.loadQuote();
  }

  loadQuote() {
    return this.props.firebase
      .quote(this.props.freight_forwarder_id, this.props.quote_id, { publicRoute: true })
      .then((quote) => {
        let currentFreightForwarder = quote.freightForwarder;
        if (currentFreightForwarder.primaryColor) {
          this.context.updateTheme({
            ...this.props.theme,
            palette: {
              ...this.props.theme.palette,
              primary: {
                ...this.props.theme.palette.primary,
                main: currentFreightForwarder.primaryColor,
                dark: darken(currentFreightForwarder.primaryColor, 0.2),
                darker: darken(currentFreightForwarder.primaryColor, 0.4),
                light: lighten(currentFreightForwarder.primaryColor, 0.2),
                lighter: lighten(currentFreightForwarder.primaryColor, 0.9),
              },
            },
          });
        }
        this.setState({
          quote,
        });
      });
  }

  render() {
    const { classes } = this.props;
    const { quote } = this.state;
    return quote ? (
      <Grid container spacing={0}>
        <div className={classes.backgroundDivStyle}>
          <Vectors className={classes.vectors} />
        </div>
        <Grid item xs={12}>
          <Grid container justifyContent="center">
            <Paper className={classes.paper}>
              <Grid container className={classes.bottomMargin}>
                <Grid item xs={6}>
                  <a target="_blank" rel="noopener noreferrer" href={quote.freightForwarder.url}>
                    <img
                      alt={quote.freightForwarder.name}
                      src={Utilities.getPhotoUrl(quote.freightForwarder.logo_images, 'logo')}
                      className={classes.logo}
                    />
                    <Typography variant="subtitle2">{quote.freightForwarder.url}</Typography>
                  </a>
                </Grid>
                <Grid item xs={6}>
                  <Grid container justifyContent="flex-end">
                    <Grid item>
                      <Typography variant="h4">Quote #{quote.quoteNumber}</Typography>
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item xs={12}>
                  <Typography className={classes.preLine} variant="subtitle2">
                    {quote.conditions_of_trade}
                  </Typography>
                </Grid>
              </Grid>
            </Paper>
          </Grid>
        </Grid>
        <Grid item xs={12} className={classes.linkRow}>
          <Grid container justifyContent="center">
            <a rel="noopener noreferrer" target="_blank" href="https://www.freightlegend.com/">
              Powered by FreightLegend
            </a>
          </Grid>
        </Grid>
      </Grid>
    ) : null;
  }
}

CustomerViewQuoteConditionsPage.contextType = ThemeContext;

CustomerViewQuoteConditionsPage.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default compose(withFirebase, withStyles(styles, { withTheme: true }))(CustomerViewQuoteConditionsPage);
